import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/Reveal';

const LAST_UPDATED = 'August 30, 2026';

function PrivacyPage() {
  return (
    <>
      <PageHeader
        eyebrow="Legal"
        title="Privacy Policy"
        lead="How the Committee to Elect Ron Johanson handles information collected through this website."
      />

      <section className="section">
        <div className="container">
          <Reveal as="div" className="legal">
            <p className="legal__updated">Last updated: {LAST_UPDATED}</p>

            <p>
              This website is operated by the Committee to Elect Ron Johanson
              (&ldquo;the Campaign,&rdquo; &ldquo;we,&rdquo; or
              &ldquo;us&rdquo;) in support of Ron Johanson&rsquo;s candidacy
              for the Chemung County Legislature, 2nd District. We respect the
              privacy of every neighbor who visits this site, and we keep what
              we collect to a minimum.
            </p>

            <h2>Information We Collect</h2>
            <p>
              <strong>Information you give us.</strong> If you use the contact
              form on our <Link to="/contact">Get Involved</Link> page, we
              receive the name, email address, and message you choose to
              submit. If you email, call, or write to us directly, we receive
              whatever you include in that message.
            </p>
            <p>
              <strong>Basic technical information.</strong> Like nearly all
              websites, our hosting provider automatically records standard
              server information such as IP address, browser type, and the
              pages requested. We use this only to keep the site running and
              secure.
            </p>
            <p>
              We do not run advertising trackers or third-party analytics on
              this site, and we do not set cookies to profile visitors. We do
              not collect payment information here &mdash; this site does not
              process contributions.
            </p>

            <h2>How We Use Information</h2>
            <ul>
              <li>To answer your question, note, or volunteer request.</li>
              <li>
                To follow up with you about the campaign &mdash; volunteering,
                yard signs, events, and Election Day &mdash; if you have
                reached out to us.
              </li>
              <li>To operate, maintain, and protect this website.</li>
              <li>
                To meet any applicable New York State election law or other
                legal requirements.
              </li>
            </ul>

            <h2>What We Do Not Do</h2>
            <p>
              We do not sell, rent, or trade your personal information. We do
              not share it with unrelated third parties for their own
              marketing. We may share information with the vendors who help us
              run the site and our email (for example, our web host or email
              provider), and only so they can perform that work for us, or
              when we are required to do so by law.
            </p>

            <h2>Links to Other Sites</h2>
            <p>
              This site links to outside pages &mdash; for example, Ron&rsquo;s
              LinkedIn profile, community Facebook pages, and local news
              coverage. Those sites are run by other organizations and have
              their own privacy practices. This policy does not cover them.
            </p>

            <h2>Children&rsquo;s Privacy</h2>
            <p>
              This site is intended for adults in and around Big Flats and
              Chemung County. We do not knowingly collect personal information
              from children under 13. If you believe a child has sent us
              information, contact us and we will delete it.
            </p>

            <h2>Your Choices</h2>
            <p>
              You can ask us at any time to tell you what information we have
              about you, correct it, remove it from our lists, or stop
              contacting you. Just reach out using the information below and
              we will take care of it.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
              If we update this policy, we will post the revised version here
              and change the date at the top of the page.
            </p>

            <h2>Contact Us</h2>
            <p>
              Committee to Elect Ron Johanson
              <br />
              656 County Road 64
              <br />
              Elmira, NY 14903
              <br />
              <a href="mailto:rnjohanson@yahoo.com">campaign@ronjohanson.com</a>
              <br />
              <a href="tel:+16077421425">(607)-742-1425</a>
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}

export default PrivacyPage;
